import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

// Debug logging to check environment variables
//console.log('🔍 DEBUG - Supabase URL:', supabaseUrl)
//console.log('🔍 DEBUG - Supabase Key:', supabaseAnonKey ? 'Present' : 'Missing')
//console.log('🔍 DEBUG - All env vars:', import.meta.env)

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('❌ Missing Supabase environment variables:', {
    url: !!supabaseUrl,
    key: !!supabaseAnonKey
  })
  throw new Error('Missing Supabase environment variables')
}

//console.log('✅ Supabase client initialized successfully')
export const supabase = createClient(supabaseUrl, supabaseAnonKey)
